<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-input
            v-model.trim="formData.keyword"
            allowClear
            :placeholder="
              $t(`请输入`) + $t(`商品名称`) + '/' + $t(`商家编码`) + '/' + $t(`商品条码`)
            "
          />
        </a-col>
        <a-col :span="8">
          <CategoryList
            ref="categoryList"
            :canNotAdd="true"
            @handleCategoryChange="changeCategory"
          />
        </a-col>
        <a-col :span="5">
          <a-select
            allowClear
            show-search
            style="width: 100%"
            v-model="formData.brandCode"
            :placeholder="$t(`请输入`) + '/' + $t(`选择`) + $t(`品牌`)"
          >
            <a-select-option
              v-for="item in brandNameOptions"
              :value="item.code"
              :key="item.brandName"
            >
              {{ item.brandName }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8" style="margin-top: 10px">
          <a-button @click="queryOmsGoodsList(1)" class="btnBgc" v-if="priv('f_oms_goods_list')">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <i class="iconfont icon-synchronize" style="margin-right: 5px"></i>
            {{ $t(`重置`) }}
          </a-button>
          <!--          <a-button type="submit" @click="exportOmsGoods">-->
          <!--            <i class="iconfont icon-upload" style="margin-right: 5px"></i>-->
          <!--            {{ $t(`导出`) }}-->
          <!--          </a-button>-->
        </a-col>
      </a-row>

      <div class="table-content">
        <div class="table-body">
          <a-table
            :columns="tableColumns"
            :data-source="tableData"
            rowKey="skuId"
            :pagination="false"
            :scroll="{ x: 1500 }"
          >
            <template slot="action2" slot-scope="text, scope">
              <a-button type="link" @click="goToDetail(scope, false)">
                {{ $t('查看详情') }}
              </a-button>
              <a-button type="link" @click="publish(scope)">
                {{ $t('同步') }}
              </a-button>
            </template>
            <template slot="goodsName" slot-scope="text, record">
              <div class="goods-name">{{ text }}</div>
              <div class="goods-main-image" v-if="record.images?.length">
                <img :src="record.images[0]" class="main-image" />
                <div class="image-list flex-ct">
                  <ImagePreview
                    :urls="record.images"
                    imgStyle="width: 50px; height: 50px;"
                    style="flex-wrap: nowrap"
                  />
                </div>
              </div>
            </template>
            <div slot="skuCode" slot-scope="text, record">
              <a-popover v-if="record.skuImageList.length > 0">
                <template slot="content">
                  <div style="width: 180px; min-height: 180px">
                    <img :src="record.skuImageList[0].url" alt="" style="width: 180px" />
                  </div>
                </template>
                <a>{{ text }}</a>
              </a-popover>
              <a v-else>{{ text }}</a>
            </div>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import http from '@service/axios'
import api from '@service/api'
import { getCookie } from '@/common/cookie'
import pagination from '@component/pagination'
import CategoryList from '@component/categoryList'
import { customCell } from '@/common'
import ImagePreview from '@component/ImagePreview'

export default {
  name: 'products',
  mounted() {
    this.queryOmsGoodsList()
    this.getbrandList()
  },
  activated() {
    let refresh = localStorage.getItem('refresh')
    if (refresh) {
      localStorage.removeItem('refresh')
      this.queryOmsGoodsList()
    }
  },
  components: {
    pagination,
    CategoryList,
    ImagePreview,
  },
  data() {
    return {
      formData: {
        keyword: undefined,
        status: undefined,
        brandCode: undefined,
        categoryCode: undefined,
        categoryName: undefined,
        tag: undefined,
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      brandNameOptions: [],
    }
  },
  computed: {
    tableColumns() {
      let list = [
        {
          dataIndex: 'goodsName',
          title: this.$t('商品名称'),
          width: 200,
          scopedSlots: { customRender: 'goodsName' },
          customCell: (record, index) => customCell(record, index, this.tableData, 'goodsCode'),
        },
        {
          title: this.$t('商家编码'),
          dataIndex: 'skuCode',
          key: 'skuCode',
          scopedSlots: { customRender: 'skuCode' },
        },
        {
          title: this.$t('商品条码'),
          key: 'barcode',
          dataIndex: 'barcode',
        },
        {
          title: this.$t('规格值'),
          key: 'styleDesc',
          dataIndex: 'styleDesc',
        },
        {
          title: this.$t('创建时间'),
          key: 'createdAt',
          dataIndex: 'createdAt',
        },
        {
          title: this.$t('商品操作'),
          key: 'action2',
          width: 200,
          fixed: 'right',
          customCell: (record, index) => customCell(record, index, this.tableData, 'goodsCode'),
          scopedSlots: { customRender: 'action2' },
        },
      ]
      return list
    },
    token() {
      return getCookie('d_session_id')
    },
    tableHeight() {
      return (window.innerHeight - 430) * this.$store.state.rate
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    reset() {
      for (let item in this.formData) {
        this.formData[item] = ''
      }
      this.$refs.categoryList.clear()
      this.pageNo = 1
      this.pageSize = 10
      this.queryOmsGoodsList(1)
    },
    uploadVideo() {
      let data = {
        goodsId: this.uploadGoodsId,
        shopCode: this.uploadShopCode,
        platform: this.uploadShopPlatform,
      }
      http({
        instance: this,
        url: api.uploadVideoToPlatform,
        type: 'post',
        data: data,
        hasLoading: false,
        success() {
          this.$success(this.$t('发布成功'))
        },
      })
    },
    getbrandList() {
      http({
        instance: this,
        type: 'post',
        url: api.brandList,
        hasLoading: true,
        data: {},
        success: (res) => {
          this.brandNameOptions = res.result.brandList
        },
        error: () => {},
      })
    },
    changeCategory(data) {
      if (data) {
        this.formData.categoryCode = data.value
        this.formData.categoryName = data.label
      } else {
        this.formData.categoryCode = undefined
        this.formData.categoryName = undefined
      }
    },
    exportOmsGoods() {
      let currentShop = this.$store.state.currentShop
      let merchantCode = this.$store.state.userSession?.merchantCode,
        buId = this.$store.getters.partyId,
        platform = currentShop?.platform
      http({
        instance: this,
        url: api.exportOMSOrder,
        data: {
          bookCode: 'ExportOmsGoods',
          mergeCode: currentShop?.uniqueCode,
          merchantShopName: currentShop?.name,
          appCode: 'OMS',
          params: {
            keyword: this.formData.keyword,
            categoryCode: this.formData.categoryCode,
            categoryName: this.formData.categoryName,
            brandCode: this.formData.brandCode,
            merchantCode,
            buId,
            platform,
            goodsIds: this.selectedGoodsKeys,
            status: this.formData.status,
          },
        },
        type: 'post',
        hasLoading: false,
        success: (res) => {
          console.log(res)
          if (res.result.task_id) {
            this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
          } else {
            this.$message.error(this.$t('创建导出任务失败'))
          }
        },
      })
    },
    queryOmsGoodsList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.$nextTick(async () => {
        let data = {
          keyword: this.formData.keyword,
          categoryCode: this.formData.categoryCode,
          categoryName: this.formData.categoryName,
          brandCode: this.formData.brandCode,
          pageNo: this.pageNo,
          platform: this.$store.state.currentShop.platform,
          pageSize: this.pageSize,
        }
        if (this.formData.status !== -1) {
          data.status = this.formData.status
        }
        if (this.formData.tag) {
          data.tag = this.formData.tag
        }
        let res = await http({
          instance: this,
          type: 'post',
          url: api.omsGoodsList,
          hasLoading: true,
          data,
        })
        let skuList = [...res.result.skuList]
        //TODO sku_status没有返回值 自己造
        skuList.forEach((item) => {
          if (item.status === 'open') {
            this.$set(item, 'sku_status', true)
          } else {
            this.$set(item, 'sku_status', false)
          }
        })
        this.tableData = skuList
        this.total = res.result.total
      })
    },
    goToDetail(record, is_edit) {
      let obj = {
        name: 'productsDetail',
        view: 'productsDetail',
        query: { id: record.goodsId, type: 'edit', is_edit },
      }
      this.addPane(obj)
      this.$router.push(obj)
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOmsGoodsList()
    },
    publish(record) {
      const url = window.location.origin + '/goodsManage/rentifyGoodsDetail?id=' + record.goodsId
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';

.btnBgc {
  background-color: $primary-color;
  color: $white;
}

.batchBgc {
  color: $primary-color;
  border-color: $primary-color;
}

.action-list {
  display: flex;
}

.flex-btns {
  &.flex {
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
  }

  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}

.mt10 {
  margin-top: 10px;
  display: block;
}

// ::v-deep .ant-modal {
//   width: 840px !important;
// }
// ::v-deep .ant-modal-content {
//   width: 840px !important;
// }
// ::v-deep .ant-modal-body {
//   max-height: 550px;
//   overflow-y: auto;
// }
</style>
